import { useState } from 'react';
import { ModalContent } from '../types';

export const useAlertModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState<ModalContent | null>(null);

  const openModal = (content: ModalContent) => {
    setModalContent(content);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setTimeout(() => setModalContent(null), 300);
  };

  return {
    isOpen,
    modalContent,
    openModal,
    closeModal,
  };
};
